export const ALERT_LIMITS_TITLE = 'Badge and map alert limits';

export const ALERT_LIMITS_HELP =
  'These limits decide the alert badge, the map colour and the needs-attention count on the Dashboard and pond cards. ' +
  'Colours on the entry screens follow the Entry thresholds in Settings; a reading dot on a pond card also turns amber or red when a value is outside these limits.';
